import { BillingService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from 'app/queries/types/TCall';
import type { jobsKeys } from './jobsKeys';

type TParams = QueryFunctionContext<ReturnType<typeof jobsKeys.unlockPricing>>;

export const createFetchJobUnlockPricingQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ jobId }], signal }: TParams) =>
    call(() => cancelOnSignal(BillingService.calculateJobUnlockPricing({ jobId }), signal));
